import { render, staticRenderFns } from "./RecommenderModal.vue?vue&type=template&id=59d6187e&scoped=true"
import script from "./RecommenderModal.vue?vue&type=script&lang=js"
export * from "./RecommenderModal.vue?vue&type=script&lang=js"
import style0 from "./RecommenderModal.vue?vue&type=style&index=0&id=59d6187e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6187e",
  null
  
)

export default component.exports